import * as ActiveStorage from "@rails/activestorage";
import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import "../channels";

Rails.start();
Turbolinks.start();
ActiveStorage.start();
